module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4Z8KxM/images/cover.jpg?1684514595236",
      "alt": "This image is the cover for the book A Star is Born, The Most Popular Guy in the School"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Star is Born, The Most Popular Guy in the School\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Sequel to Go West, Young Man"), _c('br'), _vm._v("The Most Popular Guy in the School: Book Three")])])]), _c('p', [_vm._v("Having left New York and their old lives behind them, Mark Mitchell and Bill Cromwell are settling into their new home in California, their jobs, and their college courses. At least Mark is, but when Bill’s acting career takes off, Bill leaves college—and Mark—behind to film around the world. Learning to live together was hard—being the boyfriend of a budding superstar is almost inconceivable. Though it’s a struggle to stay relevant to each other when they live in different worlds, Mark is committed to Bill and their relationship.")]), _vm._v(" "), _c('p', [_vm._v("When Mark gets an unexpected long weekend, he decides to surprise Bill on location in Maui. After all, it’s Mark’s birthday, and he wants to spend it with his lover. But in the end, Mark is the one who’s surprised when he finds Bill in bed with his costar. The combination of fame, fortune, and infidelity seems to spell the end for Bill and Mark—until a personal tragedy drags them back to New York, where it all began, and reminds them what really matters.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robbie Michaels\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0